import { getSegmentAnalytics } from './segment';
import { ifSegmentAnalyticsEnabled } from '../utils/analyticsUtils';
import store from '@/store';
import PlayOnline from '@/utils/marketing/Providers/PlayOnline';
import Utils from '@/modules/casino/utils/Utils';

export const logSegmentDepositEvent = ifSegmentAnalyticsEnabled((state: any) => {
  try {
    const analytics = getSegmentAnalytics();

    if (!analytics) {
      // console.warn('Segment Analytics not initialized');
      return;
    }

    const profileState = store.getState().profile;

    // Use the same FTD detection logic as Google Tag Manager to avoid timing issues
    let isFirstTimeDeposit = false;

    // Check if profile is fully initialized
    const profileFullyInitialized =
      profileState &&
      typeof profileState === 'object' &&
      !profileState.loading &&
      profileState.ftd !== undefined &&
      profileState.ftd !== 0 && // 0 is the default value for ftd (from initial state) // from core we receive ftd as null for first-time deposits or as a timestamp
      profileState.client_player_id !== null &&
      profileState.global_player_id !== null &&
      profileState.nin !== null;

    if (profileFullyInitialized) {
      // Convert to number to handle string values
      const ftdValue = Number(profileState.ftd);

      // If ftd is 0, this means this deposit is a first-time deposit
      isFirstTimeDeposit = !isNaN(ftdValue) && ftdValue === 0;
    }
    // Fall back to cookie check
    else {
      const ftdTimestamp = Utils.getCookie('ftd_timestamp');

      if (ftdTimestamp !== undefined && ftdTimestamp !== null) {
        const timestampValue = Number(ftdTimestamp);

        // timestamp of 0 means this is a first-time deposit
        isFirstTimeDeposit = !isNaN(timestampValue) && timestampValue === 0;
      } else {
        // If no cookie and profile not initialized, assume it's not FTD
        isFirstTimeDeposit = false;
      }
    }

    // Get the brand ID and user ID
    const brandId_userId = `${window.config.clientId || 'unknown'}_${profileState?.client_player_id || 'unknown'}`;

    // Get currency from wallet state or config
    const walletState = store.getState().wallet;
    const currency = walletState?.currency || window.config.defaultCurrency || 'RON';

    // Get deposit amount
    const value = state.depositValue;

    if (isFirstTimeDeposit) {
      // Log web_ftd event
      analytics.track('web_ftd', {
        currency: currency,
        value: value,
        brandId_userId: brandId_userId,
        gbraid: PlayOnline.getSavedField('gbraid'),
        wbraid: PlayOnline.getSavedField('wbraid'),
        gclid: PlayOnline.getSavedField('gclid'),
      });
      // console.log('Segment web_FTD event tracked successfully');
    } else {
      // Log web_deposit event
      analytics.track('web_deposit', {
        currency: currency,
        value: value,
        brandId_userId: brandId_userId,
        gbraid: PlayOnline.getSavedField('gbraid'),
        wbraid: PlayOnline.getSavedField('wbraid'),
        gclid: PlayOnline.getSavedField('gclid'),
      });
      // console.log('Segment web_deposit event tracked successfully');
    }
  } catch (error) {
    // console.error('Error logging Segment deposit event:', error);
  }
});